import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";


async function requisicaoPay(rota, dados) {
    if (!JwtService.getToken()) return { resultado: false, erro: "Sessão expirada.", msg: "Entre novamente no Desk." };
    ApiService.setHeader();
    try { return (await ApiService.postOnce(rota, dados)).data; }
    catch (e) {
        const msg = e.response?.data?.erro || e.response?.data?.msg || e.response?.data?.message || "Operação sem confirmação. Consulte a situação antes de repetir.";
        return { resultado: false, erro: msg, msg, REGISTROS: [], QUANTIDADE: 0 };
    }
}

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getPayPedidos(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }

        return requisicaoPay("payPedidos/access/listar", dados);
    }, 
    getPayPedidoIdsFluxos(context, idsFluxosDeCaixa) {
        return requisicaoPay("payPedidos/access/localizarPorIdsFluxosEmAbertoConcluido", { IDS_FLUXOS_DE_CAIXA: idsFluxosDeCaixa });
    }, 
    getPayPedido(context, dados) {
        return requisicaoPay("payPedidos/access/obter", { ID_PAY_PEDIDO: dados.id, componente: dados.componente });
    }, 
    deletePayPedido(context, dados) {
        return requisicaoPay("payPedidos/access/excluir", { ID_PAY_PEDIDO: dados.id, componente: dados.componente });
    }, 
    postPayPedido(context, dados) {
        return requisicaoPay("payPedidos/access/salvar", dados);
    }, 
    postPayPedidoGerar(context, dados) {
        return requisicaoPay("payPedidos/access/salvarGerando", dados);
    }, 
    postAtualizarStatusPedido(context, idPayPedido) {
        return requisicaoPay("payPedidos/access/atualizarStatusPedido", {ID_PAY_PEDIDO: idPayPedido});
    }, 
    postPayPedidoCancelar(context, dados) {
        return requisicaoPay("payPedidos/access/cancelar", dados);
    }, 
    postPayPedidoSincronizarAdquirente(context, idPayPedido) {
        return requisicaoPay("payPedidos/access/sincronizarAdquirente", {ID_PAY_PEDIDO: idPayPedido});
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};